(function () {
  'use strict';

  angular.module('app.instagramPostOverview')
    .factory('instagramPostOverviewService', ['$q', '$http', '$rootScope',
      function ($q, $http, $rootScope) {

        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        function getInstagrampostOverviewLineChart(url_hash, relativepath) {
          var url_getInstagrampostOverviewLineChart = $rootScope.apiUrl + 'post/getPostOverviewLineChart?url_hash=' + url_hash + '&relativepath=' + relativepath;
          return handleRequest(url_getInstagrampostOverviewLineChart);
        }

        service.getInstagrampostOverviewLineChart = getInstagrampostOverviewLineChart;

        return service;
      }]);

})();
